import React from 'react';
import { MessageSquare, Phone, MapPin, Mail, Award } from 'lucide-react';
import { Card } from '../components/ui/Card';
export function ContactUs() {
  return <div className="min-h-screen bg-gray-50 pt-40 lg:pt-52 pb-20" data-id="element-702">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-703">
        {/* Page Header */}
        <div className="text-center mb-12" data-id="element-704">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-705">Contact Us</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-706">
            Our local support team is here to answer your questions about
            classes, requirements, or technical issues.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12" data-id="element-707">
          {/* Left Column - Contact Form */}
          <Card className="p-6 lg:p-8" data-id="element-708">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-709">
              Send Us An Email Message
            </h2>

            <form className="space-y-4" data-id="element-710">
              {/* Name */}
              <div data-id="element-711">
                <label htmlFor="name" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-712">
                  Name<span className="text-red-500" data-id="element-713">*</span>
                </label>
                <input type="text" id="name" name="name" required className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm" data-id="element-714" />
              </div>

              {/* Company Name */}
              <div data-id="element-715">
                <label htmlFor="company" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-716">
                  Company Name
                </label>
                <input type="text" id="company" name="company" className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm" data-id="element-717" />
              </div>

              {/* E-mail */}
              <div data-id="element-718">
                <label htmlFor="email" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-719">
                  E-mail<span className="text-red-500" data-id="element-720">*</span>
                </label>
                <input type="email" id="email" name="email" required className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm" data-id="element-721" />
              </div>

              {/* Phone */}
              <div data-id="element-722">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-723">
                  Phone<span className="text-red-500" data-id="element-724">*</span>
                </label>
                <input type="tel" id="phone" name="phone" required className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm" data-id="element-725" />
              </div>

              {/* Subject */}
              <div data-id="element-726">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-727">
                  Subject<span className="text-red-500" data-id="element-728">*</span>
                </label>
                <input type="text" id="subject" name="subject" required className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm" data-id="element-729" />
              </div>

              {/* Message */}
              <div data-id="element-730">
                <label htmlFor="message" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-731">
                  Message<span className="text-red-500" data-id="element-732">*</span>
                </label>
                <textarea id="message" name="message" rows={4} required className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm resize-none" data-id="element-733" />
              </div>

              {/* reCAPTCHA Placeholder */}
              <div className="bg-gray-100 border border-gray-300 rounded-md p-3 flex items-center" data-id="element-734">
                <input type="checkbox" id="recaptcha" className="h-5 w-5 text-brand-purple-600 focus:ring-brand-purple-500 border-gray-300 rounded mr-2" data-id="element-735" />
                <label htmlFor="recaptcha" className="text-xs text-gray-700" data-id="element-736">
                  I'm not a robot
                </label>
                <div className="ml-auto text-right" data-id="element-737">
                  <div className="text-xs text-gray-500 font-medium" data-id="element-738">
                    reCAPTCHA
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-739">Privacy - Terms</div>
                </div>
              </div>

              {/* Submit Button */}
              <button type="submit" className="w-full px-6 py-3 bg-brand-orange-400 text-brand-purple-900 font-bold rounded-md hover:bg-brand-orange-500 transition-colors shadow-md" data-id="element-740">
                Send Message
              </button>
            </form>

            <p className="mt-4 text-center text-sm text-gray-600" data-id="element-741">
              We typically respond within 24 hours during business days
            </p>
          </Card>

          {/* Right Column - Contact Information */}
          <div className="space-y-6" data-id="element-742">
            {/* Need Help Section */}
            <div className="p-6 bg-gradient-to-br from-brand-purple-600 to-brand-purple-700 text-white rounded-xl shadow-sm" data-id="element-743">
              <h2 className="text-2xl font-bold mb-4" data-id="element-744">Need Help?</h2>
              <p className="text-brand-purple-100 mb-6" data-id="element-745">
                Our local support team is here to answer your questions about
                classes, requirements, or technical issues.
              </p>
              <a href="tel:602-377-6207" className="inline-flex items-center justify-center w-full bg-white text-brand-purple-900 px-6 py-3 rounded-full font-bold text-lg hover:bg-brand-orange-400 transition-colors shadow-lg" data-id="element-746">
                <Phone className="w-5 h-5 mr-2" data-id="element-747" />
                602-377-6207
              </a>
              <p className="text-center text-brand-purple-100 text-sm mt-3 font-medium" data-id="element-748">
                Call, Text, Chat or Email us
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}